export default {"src":"/_next/static/media/vertical-white.81c97982.svg","height":10,"width":26,"blurWidth":0,"blurHeight":0};